import Axios from '../request';

// 问卷前置接口
export function getQuestionNeedLoginApi(data) {
  return Axios.get(
    '?_m=transfers_api&_a=survey&token=?&url=/api/questionnaire/need_to_login',
    { params: data },
  );
}

// 获取问卷详情
export function getQuestionInfoApi(data) {
  return Axios.get(
    '?_m=transfers_api&_a=survey&url=/api/questionnaire/get_questionnaire',
    { params: data },
  );
}

// 提交问卷
export function submitQuestionApi(data) {
  return Axios.post(
    '?_m=transfers_api&_a=survey&url=/api/questionnaire/submit_questionnaire',
    data,
  );
}
